import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {DeviceAddDialogComponent} from "../device-add-dialog/device-add-dialog.component";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../shared/services/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {Observable, of, ReplaySubject} from "rxjs";
import {Device} from "../../../shared/interface/device";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {User} from "../../../shared/interface/user";
import {LicenseService} from "../../../shared/services/license.service";
import {HttpErrorResponse} from "@angular/common/http";
import {
  DYNAMIC_DICTIONARY_DEVICE_TYPE,
} from '../../../shared/services/dict.service';
import {Uuid} from "../../../shared/interface/response/uuid";
import {Router} from "@angular/router";

@Component({
  selector: 'app-device-add',
  templateUrl: './device-add.component.html',
  styleUrls: ['./device-add.component.scss']
})
export class DeviceAddComponent implements OnInit, OnDestroy {
  @Input() userObject?: User;
  @Input() dialogRef?: MatDialogRef<DeviceAddDialogComponent>;
  @Input() device?: Observable<Device>;
  @Output() closeModification = new EventEmitter<any>();
  @Output() deviceCreated = new EventEmitter<string>();

  readonly DYNAMIC_DICTIONARY_DEVICE_TYPE = DYNAMIC_DICTIONARY_DEVICE_TYPE;


  deviceForm: FormGroup;
  processingRequest = false;
  errors: any = {};
  deviceObject: Device;

  typeOfDeviceControl: FormControl;
  nameControl: FormControl;
  userControl: FormControl;
  serialNumberControl: FormControl;
  noteControl: FormControl;
  extensionNumberControl: FormControl;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private licenseService: LicenseService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {
    this.deviceForm = fb.group({
      typeOfDevice: this.typeOfDeviceControl = fb.control('', [Validators.required]),
      name: this.nameControl = fb.control('', [Validators.required]),
      user: this.userControl = fb.control('', [Validators.required]),
      serialNumber: this.serialNumberControl = fb.control('', [Validators.required]),
      note: this.noteControl = fb.control(''),
      extensionNumber: this.extensionNumberControl = fb.control(''),
    });
  }

  ngOnInit(): void {
    if (this.device) {
      this.device
        .pipe(takeUntil(this.destroyed$))
        .subscribe((device: Device) => {
          this.deviceObject = device;
          this.initialize(device);
        });
    } else {
      this.initialized.next(true);
    }
    if (this.userObject) {
      this.userControl.setValue(this.userObject.uuid || this.userObject);
      this.userControl.disable();
    }
  }

  initialize(deviceObject: Device): void {
    of(deviceObject)
      .pipe(
        delay(0),
        tap(() => {
          this.deviceForm.reset({
            typeOfDevice: deviceObject.typeOfDevice?.id,
            name: deviceObject.name,
            serialNumber: deviceObject.serialNumber,
            extensionNumber: deviceObject.extensionNumber,
            user: deviceObject.user?.uuid || deviceObject.user,
            note: deviceObject.note,
          });
          this.initialized.next(true);
        })
      ).subscribe();
  }

  // sendForm(): void {
  //   this.processingRequest = true;
  //
  //   this.licenseService.addDevice(this.deviceForm.getRawValue())
  //     .subscribe(() => {
  //       this.snack.open('Pomyślnie dodano urządzenie', '', {
  //         duration: 2000,
  //       });
  //       this.processingRequest = false;
  //       this.dialogRef.close();
  //     }, (error: HttpErrorResponse) => {
  //       this.processingRequest = false;
  //       this.snack.open('Podczas dodawania urządzenia wystąpił błąd', error.status.toString(), {
  //         duration: 2000,
  //       });
  //       if (error.status === 400) {
  //         this.errors = error.error.error.list;
  //         this.formHelper.setBackendErrorState(this.deviceForm, this.errors);
  //       }
  //     })
  //   ;
  // }

  sendForm(): void {
    this.processingRequest = true;
    this.licenseService.addDevice(
      this.deviceForm.getRawValue(),
      this.deviceObject ? this.deviceObject.uuid : null
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open(this.deviceObject ? 'Pomyślnie zaktualizowano urządzenie' : 'Pomyślnie dodano urządzenie', '', {
          duration: 2000,
        });
        this.processingRequest = false;

        if (this.dialogRef) {
          this.deviceCreated.emit();
          this.dialogRef.close();
        } else if (this.device) {
          this.closeModification.emit();
        } else {
          this.router.navigate(['/licencje/urzadzenia/szczegoly', response.uuid]);
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.deviceForm, this.errors);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  cancel(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }

    if (this.deviceObject) {
      this.closeModification.emit();
    }
  }

}
